import React from 'react';
import { capitalize } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

export function comparePhotoColumns({
  t,
  lang,
  taskOrderUp,
  taskOrderDown,
  taskDelete,
  history
}) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      sortable: true,
      filterable: false,
      width: 80,
      style: { textAlign: 'center' }
    },
    {
      Header: t('comparePhoto_columnServiceProvider'),
      accessor: 'serviceProviderName',
      style: { textAlign: 'center' },
      sortable: false,
      Cell: ({ original }) => original[`serviceProviderName${capitalize(lang)}`],
      filterable: false
    },
    {
      Header: t('comparePhoto_columnResult'),
      accessor: 'result',
      sortable: false,
      minWidth: 100,
      style: { textAlign: 'center' },
      Cell: ({ original }) =>
        original['status'] === 'COMPLETED' && (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`/comparePhoto/result/${original.id}`)}
          >
            {t('comparePhotoPage_look')}
          </div>
        ),

      filterable: false
    },
    {
      Header: t('comparePhoto_columnStatus'),
      accessor: 'status',
      sortable: true,
      minWidth: 100,
      Cell: ({ original }) => t(`comparePhoto_columnStatus_${original['status']}`),
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('comparePhoto_columnAction'),
      accessor: 'id',
      maxWidth: 170,
      style: { textAlign: 'center' },
      Cell: ({ original }) => (
        <div className="center" style={{ margin: '-5px 0' }}>
          <Tooltip placement="top" title={t('comparePhoto_upgrade')}>
            <IconButton
              size="small"
              children={<ArrowUpwardOutlinedIcon fontSize="small" />}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                taskOrderUp(original.id);
              }}
            />
          </Tooltip>

          <Tooltip placement="top" title={t('comparePhoto_downGrade')}>
            <IconButton
              size="small"
              children={<ArrowDownwardOutlinedIcon fontSize="small" />}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                taskOrderDown(original.id);
              }}
            />
          </Tooltip>
          <Tooltip placement="top" title={t('comparePhoto_delete')}>
            <IconButton
              size="small"
              children={<DeleteOutlineOutlinedIcon fontSize="small" />}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                taskDelete(original.id);
              }}
            />
          </Tooltip>
        </div>
      ),
      width: 200,
      filterable: false
    }
  ];
}
